<template>
    <v-dialog
        v-model = "abrir"
        @keydown.esc = "cerrar"
        max-width="750px" 
        scrollable
        persistent>
        
        <v-card>
            <v-card-title>
                <span class="headline">{{ titulo }}</span>
            </v-card-title>

            <v-card-text>
                <v-container grid-list-md>
                    <v-form ref="form" v-model = "formaValida">
                    <v-layout wrap>
                        <v-flex xs6 sm6 md6>
                            <v-text-field v-if = "nuevo"
                                ref="nombre"
                                class = "body-1"
                                v-model = "datos['nombre']"
                                label = "Nombre del curso"
                                required
                            />
                            <v-text-field v-else
                                ref="nombre"
                                class = "body-1"
                                v-model = "datos['nombre']"
                                label = "Nombre del curso"
                                disabled
                            />
                        </v-flex>
                        <v-flex xs6 sm6 md6>
                            <v-menu
                                ref="menufechaini"
                                :close-on-content-click = "false"
                                v-model = "menufechaini"
                                :nudge-right = "40"
                                :return-value.sync = "date"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px"
                            >
                                <v-text-field
                                    ref = "fechaini"
                                    class = "body-1"
                                    slot="activator"
                                    prepend-icon="mdi-calendar"
                                    label = "Fecha inicial"
                                    v-model = "datos['fechaini']"
                                    required
                                    readonly>
                                </v-text-field>
                                <v-date-picker header-color = "green darken-3" dark v-model = "datos['fechaini']" @input="$refs.menufechaini.save(datos['fechaini'])"></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex xs6 sm6 md6>
                            <v-menu
                                ref="menufechafin"
                                :close-on-content-click = "false"
                                v-model = "menufechafin"
                                class = "body-1"
                                :nudge-right = "40"
                                :return-value.sync = "date"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px"
                            >
                                <v-text-field
                                    ref = "fechafin"
                                    class = "body-1"
                                    slot="activator"
                                    prepend-icon = "mdi-calendar"
                                    v-model = "datos['fechafin']"
                                    label = "Fecha final"
                                    required
                                    readonly>
                                </v-text-field>
                                <v-date-picker header-color = "green darken-3" dark v-model = "datos['fechafin']" @input="$refs.menufechafin.save(datos['fechafin'])"></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex xs6 sm6 md6>
                            <v-select
                                ref = "trabsogasig"
                                class = "body-1"
                                :items = "['Aliado', 'Mentor', 'Trabajador Social', 'Tutor']"
                                v-model = "datos['trabsocasig']"
                                label = "Tipo de persona asignada para realizar el curso"
                                required
                            ></v-select>
                        </v-flex>
                        <v-flex xs6 sm6 md6>
                            <v-select
                                ref = "centrocom"
                                class = "body-1"
                                :items = "centrosCom"
                                v-model = "datos['centrocom']"
                                label = "Centro comunitario"
                                required
                            ></v-select>
                        </v-flex>
                        <v-flex xs6 sm6 md6>
                            <v-select
                                ref = "documento"
                                class = "body-1"
                                :items = "['Diploma', 'Constancia', 'Otro']"
                                v-model = "datos['documento']"
                                label = "Documento de entrega"
                                required
                            ></v-select>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                            <v-textarea
                                ref="descripcion"
                                class = "body-1"
                                v-model = "datos['descripcion']"
                                label = "Descripcion"
                                required
                            />
                        </v-flex>
                        <v-flex v-if = "!nuevo" xs6 sm6 md6>
                            <v-select
                                ref = "estatus"
                                class = "body-1"
                                :items = "['Abierto', 'En progreso', 'Finalizado']"
                                v-model = "datos['estatus']"
                                label = "Estatus del curso"
                            ></v-select>
                        </v-flex>
                    </v-layout>
                    </v-form>
                </v-container>
            </v-card-text>

            <v-card-actions>
                <v-spacer/>
                <v-btn
                color="blue darken-1"
                text
                @click="cerrar">Cancelar</v-btn>
                <v-btn
                color="blue darken-1"
                text
                :disabled = "activarBoton"
                @click = "guardar">Guardar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import ServiceHandler from '../../ServiceHandler';

export default {
    props: {
        datos: Object,
        abrir: Boolean,
        nuevo: Boolean,
        titulo: String
    },
    data() {
        return {
            formaValida: false,
            centrosCom: [],
            date: null,
            dateFormatted: null,
            menufechaini: null,
            menufechafin: null,
            reglas: {
                requerido: (value) => !!value || 'Campo requerido',
                email: (value) => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Correo electrónico inválido.'
                },
                numerocorrecto: (value) => {
                    const patron = /^\d*\.?\d*$/
                    return patron.test(value) || 'EL formato del numero no es correcto'
                }
            },
        }
    },
    watch: {
      date (val) {
        this.dateFormatted = this.formatDate(this.date)
      },
    },
    created () {
      this.initialize()
    },
    
    computed: {
        activarBoton(){
            if(!this.nuevo){
                return false;
            }else{
                return !this.formaValida;
            }
        }
    },
    
    methods: {  
        async initialize () {
            try{
                var tmp = await ServiceHandler.getElements("centros");
                if(tmp.length > 0){
                    for(var i=0; i<tmp.length; i++){
                        this.centrosCom.push(tmp[i].nombre);
                    }
                }
            }catch(e){
                this.error = e.message;
            }
        },
        async guardar() {
            if (!this.nuevo) {
                console.log("guardando edicion");
                try{
                    await ServiceHandler.updateElement("grupos", this.datos);
                    this.cerrar();
                    this.$emit('actualizarTabla');
                    alert("Se han guardado los cambios realizados");
                }catch(e){
                    alert("Hubo un error al guardar la información: " + e.message);
                }
            } else {
                try{
                    console.log("entrando a guardar...");
                    const temp = await ServiceHandler.getID("CU");
                    this.datos._id = "CU-" + (parseInt(temp.value.sequence_value)+1);
                    this.datos.integrantes = 0;
                    this.datos.estatus = "Abierto"
                                        
                    await ServiceHandler.insertElement("grupos", this.datos);
                    alert(`Se ha generado el nuevo grupo con ID ${this.datos._id}`);
                    this.$emit('actualizarTabla'); 
                    this.cerrar();
                }catch(e){
                    alert("Hubo un error al intentar generar el nuevo grupo: " + e.message);
                }
            }
        },
        onlyNumber ($event) {
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if ((keyCode < 48 || keyCode > 57) && keyCode !== 45) { // 46 es el punto
                $event.preventDefault();
            }
        },
        cerrar() {
            //console.log("enviando señal de cierre");
            this.$refs.form.reset();
            this.$emit('cerrarVentana');
        },
    },
}
</script>